import * as React from "react";
import { observer } from "mobx-react";
import { Card, Input, Button, Col, Switch, Row, Form } from "antd";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { AddFiles } from "Components/General/AddFilesInput/AddFiles";
import { qaAnswersStore } from "../Stores/QAAnswersStore";
import { projectsDataStore } from "Stores";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";

interface QAAnswerFormProps extends WithTranslation, ModalComponentProps {
  goBack?: () => void;
  role: API_QA_ROLE;
}

export const QAAnswerForm = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<QAAnswerFormProps> {
      handleSubmit = async (values) => {
        // this.props.form.validateFieldsAndScroll(async (err, values) => {
        //   if (!err) {
        try {
          const { t, role } = this.props;

          if (values.files) {
            values.files = values.files.map((item: API_FileDataEntity) => `@id${item.id}`);
          }
          await qaAnswersStore.save(values, { role });
          this.props.hideModal();
          if (typeof this.props.goBack === "function") {
            this.props.goBack();
          }
          notificationSuccess(t("Success"), t("Question was answered"));
        } catch (err) {
          throw err;
        }
      };
      //   });
      // }

      render() {
        const { t } = this.props;

        return (
          <Form onFinish={this.handleSubmit} className="qa-form ant-form-item-grey-label">
            <Card variant="outlined" styles={{ body: { padding: "24px 0" } }}>
              <Form.Item label={t("Files")} name="files" style={{ alignItems: "baseline" }}>
                <AddFiles fileUploadType="EXIST" />
              </Form.Item>
              <Form.Item
                label={t("Answer", { context: "noun" })}
                name="answer"
                initialValue={""}
                rules={[{ required: true }]}
                labelCol={{ lg: { span: 24 } }}
              >
                <Input.TextArea placeholder={t("Enter your answer here")} rows={4} />
              </Form.Item>
            </Card>
            <ButtonsRow justify="space-between" align="middle">
              <Col>
                {projectsDataStore.currentProject.qaModuleSettings?.preliminaryAnswers && (
                  <Row align="middle" gutter={15} justify="start">
                    <Col>
                      <Form.Item name="preliminary">
                        <Switch />
                      </Form.Item>
                    </Col>
                    <Col>
                      <div>{t("Preliminary answer")}</div>
                      <div style={{ color: "#8992a1" }}>{t("Final answer will follow later")}</div>
                    </Col>
                  </Row>
                )}
              </Col>
              <Button type="primary" htmlType="submit">
                {t("Save")}
              </Button>
            </ButtonsRow>
          </Form>
        );
      }
    }
  )
);
